/**
 * 
 */
(function navMenuDirectiveDefinition() {

    'use strict';

    angular.module('NavMenu')
        .directive('navMenu', [
            'config',
            function navMenuDirective(config) {
                return {
                    restrict: 'E',
                    templateUrl: config.resourceUrl('/components/ui/layout/nav-menu/nav-menu.html'),
                    transclude: true,
                    scope: {
                        rightMargin: '=',
                        logoutErrorText: '@',
                        loginText: '@',
                        userMenuText: '@',
                        exitText: '@',
                        organizationName: '@',
                        urlIcon: '@',
                        useRegister: '@',
                        disableExternalLogin: '@',
                        showLogin: '&',
                        onLogin: '&',
                        doLogout: '&',
                        userName: '=',
                        userNick: '='
                    },
                    controller: [
                        '$scope', 'navMenu', '$state', 'authExtend', 'storageService', '$http', '$rootScope', 'config',
                        function ($scope, navMenu, $state, authExtend, storageService, $http, $rootScope, config) {
                            $scope.ouDirectiveOptions = {};
                            $scope.isNavClosed = false;
                            $scope.helpUrl = config.helpUrl();

                            $scope.loginResult = function (result) {
                                return $scope.onLogin({ result: result });
                            };

                            $scope.logout = function (result) {
                                return $scope.doLogout({});
                            };

                            $scope.appName = function navMenuDirectiveAppName() {
                                if ($scope.organizationName) {
                                    return $scope.organizationName;
                                }
                                return config.appName();
                            };

                            $scope.menu = {
                                go: function (item) {
                                    if (item.state) {
                                        if (item.keyview) {
                                            $state.go(item.state, { key: item.keyview });
                                        } else {
                                            $state.go(item.state);
                                        }
                                    }
                                    else if (item.fn)
                                        item.fn.call(item, item);
                                }
                            };

                            $scope.selecteOu = function (selected) {
                                var item = {
                                    condition: function () {
                                        return (auth.isLogged());
                                    },
                                    text: selected.organizationalUnit.name,
                                    state: 'inicio-changeuser', keyview: selected.userId
                                };
                                $scope.menu.go(item);
                                $scope.ouDirectiveOptions.clearInput();
                            };

                            var menuItemsChanged = function () {
                                $scope.menu.items = navMenu.getItems();
                                $scope.actions = [];
                                $scope.tools = [];

                                $scope.menu.items.forEach(function (op) {
                                    if (op.items) {
                                        $scope.tools.push(op);
                                    } else {
                                        $scope.actions.push(op);
                                    }
                                });

                                $scope.menu.userItems = navMenu.getUserMenuItems();
                            };

                            $scope.toggleNav = function () {
                                $rootScope.$broadcast('toggle-Nav-Menu', !$scope.isNavClosed);
                                $scope.isNavClosed = !$scope.isNavClosed;
                            }

                            menuItemsChanged();
                            navMenu.whenItemsChange(menuItemsChanged);

                            $scope.getAssemblyVersion = function () {
                                $http({
                                    method: 'GET',
                                    url: 'Home/GetVersion'
                                }).then(function successCallback(response) {
                                    $scope.assemblyVersion = response.data;
                                }, function errorCallback(response) {
                                    // or server returns response with an error status.
                                });
                            }

                            $scope.getAssemblyVersion();

                        }
                    ]
                };
            }
        ]);
})();